import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import {
  BreadcrumbList,
  Breadcrumb,
} from '@app/infrastructure/models/breadcrumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  // TODO: remove breadcrumbs when student and admin updated to new system
  @Input() breadcrumbs: BreadcrumbList = new BreadcrumbList();
  @Input() isStaff: boolean = false;
  @Input() startPosition: number = 0;
  @Input() trail: Breadcrumb[];

  public getQueryParams(breadcrumb: Breadcrumb, index: number) {
    if (breadcrumb.queryParams && index === this.trail.length - 1) {
      return breadcrumb.queryParams;
    }
  }

  public identify(index, item: Breadcrumb) {
    return item.name;
  }
}
